import fetch,{postFrom} from '../utils/fetch';


export function searchProjectList(params) {
  return fetch({
    method: 'POST',
    url: '/projectSearch/projectList',
    data:params
  })
}

export function projectSearchCondition(params) {
  return fetch({
    method: 'POST',
    url: '/projectSearch/initProjectCondition',
    data:params
  })
}
export function initCityList(params) {
  return fetch({
    method: 'GET',
    url: '/searchBase/initCityList',
    data:params
  })
}

export function initConditionByCityCode(params) {
  return fetch({
    method: 'GET',
    url: '/searchBase/initConditionByCityCode',
    params
  })
}

export function initCommonCondition(params) {
  return fetch({
    method: 'GET',
    url: '/searchBase/initCommonCondition',
    data:params
  })
}

export function flushHouseData(params) {
  return fetch({
    method: 'POST',
    url: '/houseSearch/flushHouseData',
    data:params
  })
}
